import LithiumSettings from '@/modules/integrations/types/lithium/LithiumSettings'
import LithiumOverview from '@/modules/integrations/types/lithium/LithiumOverview'
import LithiumPromotions from '@/modules/integrations/types/lithium/LithiumPromotions'
import LithiumSyncDialog from '@/modules/integrations/types/lithium/LithiumSyncDialog'

export default Object.freeze({
  type: 'lithium',
  title: 'Integrations_Lithium',
  category: 'Integrations_Lithium_Category',
  description: 'Integrations_Lithium_Description',
  image: require('@/img/integrations/lithium.png'),
  requiresAdmin: false,
  components: {
    settings: LithiumSettings,
    overview: LithiumOverview,
    promotions: LithiumPromotions
  },
  actions: [
    {
      icon: 'el-icon-refresh',
      label: 'Integrations_Lithium_Action_Sync',
      dialog: LithiumSyncDialog,
      disabled_path: 'params.enable_promotions'
    }
  ],
  urls: {
    guide: 'https://docs.xtremepush.com/docs/third-party-integrations'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/lithium/index.js